/* Successful Shopify forms -> customer events. Install the companion custom pixel. */
(function () {
  'use strict';

  if (window.makeraAiAdsLeads || window.Shopify?.designMode) return;
  window.makeraAiAdsLeads = true;

  var storageKey = 'makera:ai-ads:pending-lead';
  var maxAge = 30 * 60 * 1000;
  var published = new Set();
  var staleMarkers = new WeakSet();
  var retryTimer;
  var attempts = 0;
  var memoryPending = null;

  function readPending() {
    try {
      var value = JSON.parse(window.sessionStorage.getItem(storageKey)) || memoryPending;
      if (value && typeof value.id === 'string' && typeof value.formId === 'string' &&
          Date.now() - value.createdAt >= 0 && Date.now() - value.createdAt < maxAge) {
        return value;
      }
      window.sessionStorage.removeItem(storageKey);
    } catch (_) { /* Storage can be unavailable in privacy modes. */ }
    return memoryPending && Date.now() - memoryPending.createdAt < maxAge ? memoryPending : null;
  }

  function formKey(form) {
    return form.id || form.getAttribute('action');
  }

  function remember(formId, provider) {
    var pending = {
      id: window.crypto?.randomUUID?.() || Date.now() + '-' + Math.random().toString(36).slice(2),
      formId: formId,
      createdAt: Date.now(),
      provider: provider || false
    };
    memoryPending = pending;
    try { window.sessionStorage.setItem(storageKey, JSON.stringify(pending)); } catch (_) { /* Optional. */ }
    attempts = 0;
  }

  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form.matches('form')) return;
    var type = form.querySelector('input[name="form_type"]')?.value;
    if (type !== 'customer' && type !== 'contact') return;
    document.querySelectorAll('[data-ai-ads-lead-success]').forEach(function (marker) {
      staleMarkers.add(marker);
    });

    // Keep only a nonce and form identity; never store or publish form field values.
    remember(formKey(form));
  }, true);

  // Klaviyo's submit event fires once on the first conversion, unlike stepSubmit.
  window.addEventListener('klaviyoForms', function (event) {
    if (event.detail?.type !== 'submit' || !event.detail.formId) return;
    remember('klaviyo:' + event.detail.formId, true);
    publishSuccesses();
  });

  function publishSuccesses() {
    var pending = readPending();
    if (!pending || published.has(pending.id)) return;
    var markers = document.querySelectorAll('[data-ai-ads-lead-success]');
    var success = pending.provider || Array.from(markers).some(function (marker) {
      var form = marker.closest('form');
      return !staleMarkers.has(marker) && form && formKey(form) === pending.formId;
    });
    if (!success) return;

    if (typeof window.Shopify?.analytics?.publish !== 'function') {
      if (!retryTimer && attempts++ < 30) {
        retryTimer = window.setTimeout(function () {
          retryTimer = null;
          publishSuccesses();
        }, 500);
      }
      return;
    }

    try {
      var accepted = window.Shopify.analytics.publish('lead_created', {
        event_id: pending.id
      });
      if (accepted === false) return;
      published.add(pending.id);
      memoryPending = null;
      window.sessionStorage.removeItem(storageKey);
    } catch (_) { /* Tracking must never interrupt a form. */ }
  }

  // Also handle sections inserted by quick views or AJAX form responses.
  var observer = new MutationObserver(function (mutations) {
    if (mutations.some(function (mutation) { return mutation.addedNodes.length > 0; })) {
      publishSuccesses();
    }
  });
  observer.observe(document.documentElement, { childList: true, subtree: true });
  publishSuccesses();
})();
